import { Link } from 'react-router-dom'
import css from './shell.module.css'
import { useFleetHealth, useRuns } from '../data/queries'
import { summarise } from '../data/map/costs'
import { toFleetStatus } from '../data/map/health'
import { usd, tokens } from '../lib/money'

/**
 * The spec's strip carries "/ $120 envelope" and "month to date $812 / $2,400".
 * Neither envelope is in any table, so neither is here: the strip shows spend
 * and omits the denominator rather than inventing one. Same for "queue cleared
 * 6 days running", which needs decision history that does not exist yet.
 *
 * It also carries whether the fleet is working, because the strip is already on
 * every signed-in view and already carries fleet-wide facts. What the line says
 * is decided in `map/health.ts`; this renders it and colours it.
 */
export function CostStrip() {
  const runs = useRuns()
  const summary = runs.data ? summarise(runs.data) : null
  const health = useFleetHealth()
  const status = toFleetStatus(health.data, health.isError)

  return (
    <div className={css.costStrip}>
      <div className={css.costInner}>
        <span className="microLabel">Spend today</span>
        <span className={`${css.costAmount} mono`}>
          {summary ? usd(summary.todaySpend, { precise: summary.todaySpend < 1 }) : '—'}
        </span>
        <span className="mono">
          {summary ? `${summary.todayRuns} ${summary.todayRuns === 1 ? 'run' : 'runs'}` : ''}
        </span>
        <span className="mono">
          {summary && summary.todayOutputTokens > 0 ? `${tokens(summary.todayOutputTokens)} output tokens` : ''}
        </span>

        {/* Sits between the spend figures and the Costs link so that neither
            moves when the sentence grows: the line takes the slack, and the
            two states differ by colour alone -- no pill, no icon, no count
            badge. It is a link only when there is something to open; a link to
            an empty filter is the digging this line exists to save. */}
        {status ? (
          status.href ? (
            <Link
              to={status.href}
              className={status.tone === 'fail' ? `${css.fleetStatus} ${css.fleetStatusFail}` : css.fleetStatus}
            >
              <span className={css.fleetStatusText}>{status.line}</span>
            </Link>
          ) : (
            <span className={status.tone === 'fail' ? `${css.fleetStatus} ${css.fleetStatusFail}` : css.fleetStatus}>
              <span className={css.fleetStatusText}>{status.line}</span>
            </span>
          )
        ) : null}

        <span className={css.costSpacer} />
        <Link to="/costs">Costs →</Link>
      </div>
    </div>
  )
}
